import PrideCopy from 'components/Icons/PrideCopy';
import UITooltip from 'components/Others/UITooltip';
import useCopyToClipboard from 'hooks/useCopyToClipboard';

export const PrideDiscountBanner = () => {
    const [value, copy] = useCopyToClipboard();
    const discountCode = 'SUNNY';

    return (
        <div className="mb-4">
            <div
                className='flex items-center h-[48px] rounded-[6px] overflow-hidden md:w-full max-w-[450px]'
                style={{
                    background: 'linear-gradient(84deg, #FFB800 -6.51%, #FFF500 26.42%, #10EB22 48.98%, #0CABF4 72.76%, #9718FC 94.38%)',
                }}
            >
                <div className='flex items-center justify-between w-full px-[8px]'>
                    <div className='flex items-center w-full '>
                        <div className='bg-[#FF0099] rounded-full px-[9px] py-[5px] min-w-[80px] text-center'>
                            <p className='font-medium text-[14px] text-white'>50% off All Sunglasses</p>
                        </div>

                        {/* <div className='ml-2'>
                            <p className='font-medium text-[#2A2A2A] text-[14px] font-graphik tracking-[-0.14px]'>
                                {`25% Off EVERYTHING`}
                            </p>
                        </div> */}

                        <div className='flex items-center justify-center gap-[10px] flex-1 bg-white rounded-[3px] px-2 py-1.5 ml-5'>
                            <p className='text-[#2A2A2A] text-[14px] font-graphik font-normal tracking-[-0.14px]'>
                                <span className='hidden md:inline'>Enter code: </span>{discountCode}
                            </p>
                            <UITooltip
                                id="pride-copy-tooltip"
                                place='top'
                                messageWrapperClassName='whitespace-pre text-[#2A2A2A] h-[25px]'
                                message={value === discountCode ? 'Copied!' : 'Copy Code'}
                                tooltipWrapperClassName='!rounded-[4px] border !border-[#E2E2E2] border-solid !bg-white w-[100px] text-center'
                            >
                                <button
                                    className='text-[#2A2A2A] hover:text-[#2A2A2A]/90 flex items-center justify-center'
                                    aria-label='Copy code'
                                    onClick={() => copy(discountCode)}
                                >
                                    <PrideCopy />
                                </button>
                            </UITooltip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}; 